import { ReactNode, useMemo } from 'react'
import cn from 'classnames'

import Mirror from 'src/icons/mirror.webp'

import {
    TextLandDe,
    TextLandEn,
    TextLandRo,
    TextLandEs,
} from './text-second-step'

import { textBtn } from './mock'
import styles from './styles.module.scss'
import { CustomButton } from '../../button/CustomButton'
import { useControlModal, ModalType } from '@rockstar/registration-component'
import { SignUp } from 'src/features/registration/SignUp'
import type { TLang } from 'src/constants/langs'

type TProps = {
    lang: TLang
}

const textByLang: Record<string, ReactNode> = {
    ro: <TextLandRo />,
    de: <TextLandDe />,
    es: <TextLandEs />,
    en: <TextLandEn />,
}

export const SecondStep = ({ lang }: TProps) => {
    const renderTextContent = textByLang[lang] ?? <TextLandEn />
    const styleByLang = lang === 'de' ? lang : 'en'
    const styleBtnByLang = lang === 'en' ? lang : 'de'

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    const handleClick = () => {}
    const { modalType, setModalType } = useControlModal()

    const MODALS = useMemo<{ [key in ModalType]: ReactNode | null }>(
        () => ({
            sign_up: <SignUp language={lang} />,
            clear: null,
        }),
        [lang],
    )

    return (
        <div
            className={cn(
                styles.wrapper_mirror,
                styles[`wrapper_mirror__${styleByLang}`],
            )}
            style={{ backgroundImage: `url(${Mirror})` }}
        >
            <div
                className={cn(
                    styles.container,
                    styles[`container__${styleByLang}`],
                )}
            >
                {renderTextContent}
            </div>
            <div className={cn(styles.wrapper_button)} onClick={handleClick}>
                <CustomButton
                    onClick={() => setModalType('sign_up')}
                    textBtn={getBtnTextByLang()}
                    classNames={{
                        textBtn: cn(
                            styles.textBtn,
                            styles[`textBtn__${styleBtnByLang}`],
                        ),
                    }}
                />
            </div>
            {MODALS[modalType]}
        </div>
    )
}
